import { PageTypeEnum } from 'common/enums/PageTypeEnum'

export const pageRemovalExclusions: PageTypeEnum[] = [
  PageTypeEnum.WebsiteHome,
  PageTypeEnum.WebsitePricing,
]
